module.exports = __webpack_public_path__ + "img/select-shadow.84987079.png";